import {
    Flex,
    Grid,
    GridProps,
    Heading,
    Text,
} from '@chakra-ui/react';
import { Icon, IconsNames, RichText } from 'shared';
import { CulinaryStudioArticleIncludedServiceModel } from 'entities';
import React from 'react';

export type CulinaryStudioArticlePageMainIncludedServicesSectionProps = {
    culinaryStudioArticleIncludedServices: CulinaryStudioArticleIncludedServiceModel[]
} & GridProps & React.RefAttributes<HTMLDivElement>;

export const CulinaryStudioArticlePageMainIncludedServicesSection
: React.FC<CulinaryStudioArticlePageMainIncludedServicesSectionProps> = ({
    culinaryStudioArticleIncludedServices,
    ...props
}) => (
    <Grid
        gap="2rem"
        {...props}
    >
        <Heading
            size="md"
        >
            В состав услуги входит
        </Heading>
        <Flex
            flexDirection="row"
            flexWrap="wrap"
            gap="2rem"
        >
            {culinaryStudioArticleIncludedServices.map(({
                name,
                description,
            }) => (
                <Grid
                    width="fit-content"
                    gap="0.25rem"
                >
                    <Grid
                        width="fit-content"
                        gap="0.5rem"
                        templateColumns="auto auto"
                        height="fit-content"
                    >
                        <Icon iconName={IconsNames.Done} />
                        <Text
                            margin="auto"
                            fontSize="1rem"
                            fontWeight={900}
                        >
                            {name}
                        </Text>
                    </Grid>
                    <RichText content={description} />
                </Grid>
            ))}
        </Flex>
    </Grid>
);
